import { useRef } from "react";
import {
  Button,
  Container,
  createStyles,
  Group,
  Radio,
  Table,
  Text,
  TextInput,
  Title,
} from "@mantine/core";
import { ItemsProgressBox } from "./ItemsProgressBox";

const useStyles = createStyles((theme) => ({
  floatingDiv: {
    display: "flex",
    flexDirection: "row",
    position: "sticky",
    top: 5,
    // border: 'solid',
    backgroundColor: theme.white,
    zIndex: 5000,
  },
  columnTitles: {
    fontWeight: "bold",
    fontSize: "1.3rem",
    color: theme.colors.orange,
    position: "fixed",
  },
  tableHeaderCell: {
    fontWeight: "bold",
    fontSize: "1.3rem",
    color: theme.colors.orange,
  },
  rowName: {
    fontWeight: "bold",
  },
  button: {
    color: theme.white,
    backgroundColor: theme.colors.orange,
    paddingInline: 40,
    "&:hover": {
      color: theme.colors.orange,
      backgroundColor: theme.white,
    },
  },
  buttonSecondary: {
    color: theme.colors.orange,
    backgroundColor: theme.white,
    paddingInline: 40,
    "&:hover": {
      color: theme.white,
      backgroundColor: theme.colors.orange,
    },
  },
  groupTitle: {
    fontWeight: "bold",
  },
  info: {
    fontStyle: "italic",
    marginTop: theme.spacing.xs,
  },
  th: {
    width: 140,
  },
}));

// TODO fix types and input
export const RatePage = ({
  setScore,
  data,
  totalScore,
  maxScore,
  next,
  setComment,
  setTraineeId,
  traineeId,
  scores,
  comments,
  leave,
  note,
  unselectedItems,
}: any) => {
  const { classes } = useStyles();
  const itemRef = useRef<any>([]);

  return (
    <div>
      <div className={classes.floatingDiv}>
        {unselectedItems.length > 0 && (
          <ItemsProgressBox
            itemsToDisplay={unselectedItems}
            handleClick={() => itemRef.current.scrollIntoView()}
          />
        )}
      </div>
      <form onSubmit={next}>
        <Container>
          <Table>
            <thead>
              <tr>
                <th align="center">
                  <Text color="orange">ITEM</Text>
                </th>
                <th align="center">
                  <Text color="orange">BEHAVIOUR DEMONSTRATED</Text>
                </th>
                <th align="center" className={classes.th}>
                  <Text color="orange">NOT DONE (0)</Text>
                </th>
                <th align="center" className={classes.th}>
                  <Text color="orange">ATTEMPTED / PROMPTED (1)</Text>
                </th>
                <th align="center" className={classes.th}>
                  <Text color="orange">COMPLETED (2)</Text>
                </th>
                <th align="center">
                  <Text color="orange">COMMENTS</Text>
                </th>
              </tr>
            </thead>
            <tbody>
              {data.map((row: any, index: any) =>
                row.item === null ? (
                  <tr key={index}>
                    <td align="left"></td>
                    <td align="left">
                      <Title order={6} color="orange">
                        {row.name}
                      </Title>
                    </td>
                    <td align="left"></td>
                    <td align="left"></td>
                    <td align="left"></td>
                    <td align="left"></td>
                  </tr>
                ) : (
                  <tr key={index} ref={() => itemRef.current.push(index)}>
                    <td className={classes.rowName} align="center">
                      <Title order={6}>{row.item}</Title>
                    </td>
                    <td align="left">
                      <Text>{row.name}</Text>
                    </td>
                    <td align="center">
                      <Radio
                        color="orange"
                        checked={scores[row.id] === 0}
                        onChange={() => setScore(row.id, 0)}
                        value={"0"}
                      />
                    </td>
                    <td align="center">
                      <Radio
                        color="orange"
                        checked={scores[row.id] === 1}
                        onChange={() => setScore(row.id, 1)}
                        value={"1"}
                      />
                    </td>
                    <td align="center">
                      <Radio
                        color="orange"
                        checked={scores[row.id] === 2}
                        onChange={() => setScore(row.id, 2)}
                        value={"2"}
                      />
                    </td>
                    <td align="left">
                      <TextInput
                        key={row.name}
                        id={row.name}
                        onChange={(event) => {
                          setComment(row.id, event.target.value);
                        }}
                        defaultValue={comments[row.id]}
                      />
                    </td>
                  </tr>
                )
              )}
              <tr key="score">
                <th scope="row">
                  <Title order={5}>
                    Total: {totalScore}/{maxScore}
                  </Title>
                </th>
                <td align="left">
                  <TextInput
                    key="Trainee ID"
                    id="Trainee ID"
                    onChange={(event) => {
                      setTraineeId(event.target.value);
                    }}
                    label="Trainee ID"
                    required
                    defaultValue={traineeId}
                  />
                </td>
                <td align="left"></td>
                <td align="left"></td>
                <td align="left"></td>
              </tr>
            </tbody>
          </Table>
          <Group position="right">
            <Button color="orange" onClick={leave}>
              BACK
            </Button>
            <Button color="orange" type="submit">
              NEXT
            </Button>
          </Group>
          <Text className={classes.info}>{note}</Text>
        </Container>
      </form>
    </div>
  );
};
